import React from "react";
// Common Components
import { Button, Modal, FileDownloader } from "src/Components";
import TableTemplate from "./TableTemplate";
import { CommonTableUI } from "./CommonTableUI";
// Local Components
import SettingModal from "./Setting";
// Requests
import { getMarginTable, getMarginExcelFile } from "src/Requests/imePortfolio";
// Types
import {
  IMarginSearchParams,
  IMarginTableReport,
} from "src/Interfaces/imePortfolio";

const Margin: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="w-full h-full flex flex-col items-center p-5">
      {isOpen ? (
        <Modal
          UI={<SettingModal onClose={() => setIsOpen(false)} />}
          onClose={() => setIsOpen(false)}
          modalBoxClassName="!min-w-[300px]"
        />
      ) : (
        <></>
      )}
      <div className="w-80 self-start flex gap-4 items-center">
        <Button
          onClick={() => setIsOpen(true)}
          text="تنظیمات"
          variant="contained"
        />
        <FileDownloader getFile={getMarginExcelFile} />
      </div>
      <TableTemplate<IMarginSearchParams, IMarginTableReport>
        TableUI={({ reports, onAction, sortingType, setSortingType }) => {
          return (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              tableBoxClassName="max-h-[700px] overflow-auto"
            />
          );
        }}
        getDataTable={getMarginTable}
        withSort
      />
    </div>
  );
};

export default Margin;
